import { PayloadAction, createSlice } from "@reduxjs/toolkit";

export type GlobalState = Readonly<{
  topUpOrgId: number;
  globalOrgId: number;
  globalOrgIds: number[];
  callInitiated: boolean;
}>;

export const initialState: GlobalState = {
  topUpOrgId: 0,
  globalOrgId: 0,
  globalOrgIds: [],
  callInitiated: false,
};

export const globalSlice = createSlice({
  name: "global",
  initialState,
  reducers: {
    setTopUpOrgId: (state, action: PayloadAction<number>) => {
      state.topUpOrgId = action.payload;
    },
    setGlobalOrgId: (state, action: PayloadAction<number>) => {
      state.globalOrgId = action.payload;
    },
    setGlobalOrgIds: (state, action: PayloadAction<number[]>) => {
      state.globalOrgIds = action.payload;
    },
    setCallInitiated: (state, action: PayloadAction<boolean>) => {
      state.callInitiated = action.payload;
    },
  },
});

export const {
  setTopUpOrgId,
  setGlobalOrgId,
  setGlobalOrgIds,
  setCallInitiated,
} = globalSlice.actions;

export const globalReducer = globalSlice.reducer;
